const phoneTypes = {
  mobile: {
    display: 'Mobile',
    value: 'mobile',
  },
  home: {
    display: 'Home',
    value: 'home',
  },
  work: {
    display: 'Work',
    value: 'work',
  },
};

export default phoneTypes;
